import React from 'react';
import KmoCta from '../KmoCta';
import MkIcon from '../MkIcon';
import MkReviewCard from '../MkReviewCard';
import { REVIEWS } from '../../../marketing/reviews';

const STEPS = [
  {
    icon: 'calendar',
    title: 'Choose how long',
    body: 'Dial in hours and minutes, or set a schedule for the hours you always lose.',
  },
  {
    icon: 'lock',
    title: 'Tap Lock',
    body: "Your phone stays locked until the time is up. That's the point.",
  },
  {
    icon: 'apps-check',
    title: 'Keep what matters',
    body: 'Allow an app you need, and turn on emergency calling for the contacts you choose.',
  },
];

// H3 — how Keep Me Out works, in three steps.
const HomeHow = ({ platform }) => (
  <section className="mk-how section" id="how" aria-labelledby="mk-how-title">
    <div className="container-sm">
      <div className="section-inner">
        <div className="mk-head reveal-from-bottom">
          <p className="mk-eyebrow">How Keep Me Out works</p>
          <h2 id="mk-how-title" className="mk-h2">
            Set it once. Then get on with your day.
          </h2>
        </div>
        <ol className="list-reset mk-steps">
          {STEPS.map((s, i) => (
            <li
              key={s.title}
              className="mk-steps__item reveal-from-bottom"
              data-reveal-container=".mk-steps"
              data-reveal-delay={i * 120}
            >
              <div className="mk-card mk-step">
                <span className="mk-step__num" aria-hidden="true">
                  {i + 1}
                </span>
                <span className="mk-icon-tile">
                  <MkIcon name={s.icon} />
                </span>
                <h3 className="mk-h3">{s.title}</h3>
                <p className="mk-body">{s.body}</p>
              </div>
            </li>
          ))}
        </ol>
        <div className="mk-how__quote reveal-scale-up">
          <MkReviewCard review={REVIEWS.alaa} variant="featured" />
        </div>
        <div className="mk-how__cta">
          <KmoCta placement="home_how" platform={platform} />
        </div>
      </div>
    </div>
  </section>
);

export default HomeHow;
